import { findAllAddresses } from '@src/main/modules/messages/application/use-cases/find/find-all-addresses.usecase';
import { AddressRepository } from '@src/main/modules/messages/domain/address/address.repository';
import { createAddressHttpRepository } from '@src/main/modules/messages/infrastructure/repository/AddressHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useAddresses = () => {
  const { user } = useAuth();
  const [repository, setRepository] = useState<AddressRepository | null>(null);

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  useEffect(() => {
    if (user?.token) {
      const repo = createAddressHttpRepository(tokenProvider);
      setRepository(repo);
    } else {
      setRepository(null);
    }
  }, [user?.token, tokenProvider]);

  const queryResult = useQuery({
    queryKey: ['address'],
    queryFn: async () => {
      if (!repository) throw new Error('Repository not available');
      return await findAllAddresses(repository);
    },
    enabled: !!repository,
    staleTime: 1000 * 60,
  });

  return { ...queryResult, repository };
};
